import { Component, OnInit, ChangeDetectionStrategy, Input, SimpleChanges } from '@angular/core';
import {NzModalService} from "ng-zorro-antd";
import { ProductMedia, ProductPromotionalMaterial, ProductVideo } from '../../models/product-media.model';

interface FilterButtonModel {
  label: String;
  value: String;
  selected: Boolean;
}

@Component({
  selector: 'leap-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.less', '../../styles/tab-content.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class MediaComponent implements OnInit {

  @Input() videos: Array<ProductVideo>;
  @Input() promotionalMaterials: Array<ProductPromotionalMaterial>;

  constructor(private modalService: NzModalService) {
  }

  public filterMediaTypeOptions: Array<FilterButtonModel>;
  public allMaterials: Array<ProductMedia>;
  public filterMediaType = 'all';

  ngOnInit() {
    this.initAllData();
    this.sortInputData();
    this.initFilterMediaTypeOptions();
  }

  private initFilterMediaTypeOptions() {
    this.filterMediaTypeOptions = [{
      label: 'All (' + this.allMaterials.length + ')', value: 'all', selected: true
    },
      {
        label: 'Samples (' + this.promotionalMaterials.length + ')', value: 'promotionalMaterials', selected: false
      },
      {
        label: 'Videos (' + this.videos.length + ')', value: 'videos', selected: false
      }];
  }

  public filterByMediaType(mediaType: string) {
    if(this.filterMediaType !== mediaType){
      this.filterMediaType = mediaType;
    }
  }

  private sortInputData() {
    this.allMaterials.sort((a, b) => (a.title > b.title) ? 1 : -1);
  }

  private initAllData() {
    this.allMaterials = [...this.videos.map(v => { return {...v,type:'videos'}}),
      ...this.promotionalMaterials.map(p => { return {...p, type:'promotionalMaterials'}})];
  }
}
